import './_news-cards.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function NewsCards() {
    const newsCardsCarousel = document.querySelectorAll('.news-cards');

    if (newsCardsCarousel.length) {
        newsCardsCarousel.forEach((item, index) => {
            const carouselNews = item.querySelector('.news-cards-carousel') as HTMLElement;
            const swiperContainer = carouselNews.querySelector('.views-element-container') as HTMLElement;
            swiperContainer.setAttribute('id', `swiper-news-${index}`);
            const swiperWrapper = swiperContainer.querySelector('.cactus_view_rows') as HTMLElement;
            const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
            const swiperBtnNext = carouselNews.querySelector('.swiper-button-next') as HTMLElement;
            const swiperBtnPrev = carouselNews.querySelector('.swiper-button-prev') as HTMLElement;
            const swiperPagination = carouselNews.querySelector('.swiper-pagination') as HTMLElement;

            const totalCardsDsk = Array.from(item.querySelectorAll('.card-wrapper .swiper-slide'));
            const maxTotalCardsDsk = (item.querySelector('.card-wrapper') as HTMLElement).getAttribute('data-limit-card');

            const maxTotalCardsMobile = (item.querySelector('.mobile') as HTMLElement).getAttribute('data-limit-card');

            if (totalCardsDsk.length > Number(maxTotalCardsDsk)) {
                const cardsToShow = totalCardsDsk.splice(0, Number(maxTotalCardsDsk));
                cardsToShow.forEach(card => {
                    card.classList.add('to-show');
                });

                totalCardsDsk.forEach(card => {
                    if (!card.classList.contains('to-show')) {
                        card.remove();
                    }
                });
            }

            if (swiperWrapper) {
                swiperContainer.classList.add('swiper');
                swiperWrapper.classList.add('swiper-wrapper');

                if (slides.length > Number(maxTotalCardsMobile)) {
                    const cardsToShow = slides.splice(0, Number(maxTotalCardsMobile));
                    cardsToShow.forEach(card => {
                        card.classList.add('to-show');
                    });

                    slides.forEach(card => {
                        if (!card.classList.contains('to-show')) {
                            card.remove();
                        }
                    });
                }
            }

            const swiper = new Swiper(swiperContainer, {
                modules: [Navigation, Pagination],
                pagination: {
                    el: swiperPagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperBtnNext,
                    prevEl: swiperBtnPrev,
                    addIcons: false,
                },
                loop: slides.length > 1,
                slidesPerView: 1.5,
                slidesPerGroup: 1,
                spaceBetween: 16,
                on: {
                    afterInit: function () {
                        const bullets = swiperPagination.querySelectorAll('.swiper-pagination-bullet');
                        bullets.forEach((bullet: any) => {
                            bullet.setAttribute('tabindex', '0');
                            bullet.addEventListener('keydown', (event: any) => {
                                if (event.key === 'ArrowLeft') {
                                    event.preventDefault();
                                    swiper.slidePrev();
                                } else if (event.key === 'ArrowRight') {
                                    event.preventDefault();
                                    swiper.slideNext();
                                }
                            });
                        });
                    },
                    slideChange: function () {
                        if (swiperPagination) {
                            const currentSlide = swiperPagination.querySelector('.swiper-pagination-bullet.swiper-pagination-bullet-active') as HTMLDivElement;
                            if (currentSlide) {
                                currentSlide.focus();
                            }
                        }
                    },
                },
            });

            if (swiperBtnNext) {
                swiperBtnNext.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        swiper.slideNext();
                    }
                });
            }

            if (swiperBtnPrev) {
                swiperBtnPrev.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        swiper.slidePrev();
                    }
                });
            }

            swiper.init();
        });
    }
}
